import { Elements } from '@stripe/react-stripe-js'
import type { SubscriptionResponse } from '@super/shared-types'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { StripeCardForm } from '@/components/billing/StripeCardForm'
import { billingClient } from '@/lib/api/billing.client'
import { stripePromise } from '@/lib/stripe'

interface UpdateCardModalProps {
  open: boolean
  onClose: () => void
  onCardUpdated: (subscription: SubscriptionResponse) => void
}

export function UpdateCardModal({
  open,
  onClose,
  onCardUpdated,
}: UpdateCardModalProps) {
  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Update card</DialogTitle>
          <DialogDescription>
            Your new card replaces the current one immediately. Your plan and
            billing cycle are unchanged.
          </DialogDescription>
        </DialogHeader>
        <Elements stripe={stripePromise}>
          <StripeCardForm
            submitSetupIntent={setupIntentId =>
              billingClient.updatePaymentMethod({ setupIntentId })
            }
            onSuccess={subscription => {
              onCardUpdated(subscription)
              onClose()
            }}
            ctaLabel="Update card"
            ctaPlacement="inline"
          />
        </Elements>
      </DialogContent>
    </Dialog>
  )
}
